import { css } from "@emotion/react"

export const mobileLayoutContainerStyle = css`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  font-size: 14px;
`

export const headerContainerStyle = css`
  display: flex;
  width: 100%;
  padding: 12px 16px 12px 6px;
  justify-content: space-between;
  align-items: center;
`

export const menuIconHotSpot = css`
  font-size: 20px;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
`

export const drawContainerStyle = css`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`

export const navigationContainerStyle = css`
  width: 100%;
  padding: 22px 16px;
`

export const navigationMenuStyle = css`
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
`

export const menuContainerStyle = css`
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: space-between;
`

export const leftContainerStyle = css`
  width: 240px;
  height: 100%;
  display: flex;
  flex: none;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
`

export const tipsContainerStyle = css`
  width: 100%;
  padding: 8px 16px;
`

export const dynamicMenuContainerStyle = css`
  width: 100%;
`

export const leftBottomContainerStyle = css`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`

export const childrenContainerStyle = css`
  width: 100%;
  height: 100%;
  overflow: hidden;
`
